import { render, staticRenderFns } from "./MoquGameManagement.vue?vue&type=template&id=2a16ccb0&scoped=true"
import script from "./MoquGameManagement.vue?vue&type=script&lang=js"
export * from "./MoquGameManagement.vue?vue&type=script&lang=js"
import style0 from "./MoquGameManagement.vue?vue&type=style&index=0&id=2a16ccb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16ccb0",
  null
  
)

export default component.exports